var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{staticClass:"mb-3 mt-3 card-goso-stats height-600"},[_c('CategoryDrilldown')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }